import SysColumn from "app/class/sys-column";

export const PASSWORD_MASK = "***********";

const hasValue = (value: unknown) => value !== null && value !== undefined && value !== "";

export const encryptedValueFieldName = (fieldName: string) => `${fieldName}_encrypted`;

export const hasStoredPasswordValue = (
    fieldName: string,
    value: unknown,
    row?: Record<string, any>
) => hasValue(value) || hasValue(row?.[encryptedValueFieldName(fieldName)]);

export const sanitizePasswordPayloadValues = (
    values: Record<string, any>,
    columns: SysColumn[] = []
) => {
    const nextValues = { ...values };

    columns
        .filter((column) => column.column_type === "PASSWORD")
        .forEach((column) => {
            const value = nextValues[column.name];

            if (!hasValue(value) || value === PASSWORD_MASK) {
                delete nextValues[column.name];
            }
        });

    return nextValues;
};
